module.exports = __webpack_public_path__ + "static/media/11NEPAD12.5af76e96.jpg";